import React from 'react';
import socketIOClient from 'socket.io-client';

import Header from './Header';
import Groups from './Groups';
import Group from './Group';
import Chat from './Chat';

import './Container.css';

export default class Container extends React.Component {
	constructor (props) {
		super(props);
		this.state = {
			conversation: false
		};
	}

	socket = null

	componentDidMount() {
		// Load groups
		this.props.callAPI({ action: "GET_GROUPS" })
			.then(response => response.json())
			.then(data => {
				this.props.setGroups(data);
				
				// Restore previously opened group
				const groupId = Number(this.props.cookies.group_id);

				if (groupId) {
					const group = data.find(g => g.id === groupId);

					this.openConversation(group);
				}
			})
			.catch(err => console.log(err));

		// Start Web Socket
		this.socket = socketIOClient(process.env.REACT_APP_SOCKET_SERVER);

		this.socket.on("echo", (data) => {
			this.updateConversation(data);
			this.props.setSentMessage(true);
		});

		this.socket.on("typing", (data) => {
			const { from } = data;
			
			if (from.id !== this.props.currentUser.id) {
				this.props.showIsTyping(data);
			}
		});
	}

	componentWillUnmount() {
		this.socket.disconnect();
	}

	verifyLogin = () => {
		if (this.props.cookies.user_id && this.props.cookies.user_token) {
			const theData = {
				action: "GET_LOGIN_STATUS",
				id: this.props.cookies.user_id,
				token: this.props.cookies.user_token
			};

			this.props.callAPI(theData)
				.then(response => response.json())
				.then(data => {
					this.props.setCurrentUser(false);

					if (data.id) {
						//  assign the current user
						this.props.setCurrentUser(data);
					}
				})
				.catch(err => console.log(err));
		}
	}

	preloadMessages = (theGroup, theMessages, defaultAction = true) => {
		if (!defaultAction) {
			this.props.setCount(prevCount => prevCount + 1);
		} else {
			this.verifyLogin();
		}

		// Select the group
		const updatedGroup = this.props.groups.find(group => group.id === theGroup.id);

		// Update the group's messages value
		updatedGroup.messages = theMessages;

		// Update the application state for "groups"
		const newGroups = this.props.groups.map((group) => {
			if (group.id === updatedGroup.id) {
				return updatedGroup;
			}
			
			return group;
		});

		this.props.setGroups(newGroups);
	}

	getGroupMessages = (input) => {
		const theData = { action: "GET_MESSAGES", ...input };
		const theParams = {
			method: "POST",
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify(theData)
		};

		return fetch(process.env.REACT_APP_ENDPOINT, theParams)
	}

	openConversation = (group) => {
		this.closeConversation();

		this.getGroupMessages({ lastId: 0, groups: group.id })
			.then(response => response.json())
			.then(data => {
				const sortedData = data.reverse();

				this.preloadMessages(group, sortedData);

				this.setState({ conversation: group });

				// Save cookie
				this.props.setCookie("group_id", group.id);
			})
			.catch(err => console.log(err));
	}

	triggerLoadMore = (group, lastChatID) => {
		const messages = this.state.conversation.messages;

		const theData = { lastId: lastChatID, groups: group.id };

		this.getGroupMessages(theData)
			.then(response => response.json())
			.then(data => {
				const newMessages = data.reverse();
				const updatedMessages = [
					...newMessages,
					...messages,
				];

				this.preloadMessages(group, updatedMessages, false);
			})
			.catch(err => console.log(err));

		// Delay before allowing user to load more
		setTimeout(() => {
			this.props.setCount(0);
		}, 3000);
	}

	closeConversation = () => {
		this.setState({ conversation: false });

		// Unset cookie
		this.props.setCookie("group_id", 0);
	}

	updateConversation = (payload) => {
		const groupId = payload.to.id;
		const updatedGroup = this.props.groups.find(group => group.id === groupId);

		updatedGroup.messages.push(payload);
		
		const newState = this.props.groups.map((group) => {
			if (group.id === updatedGroup.id) {
				return updatedGroup;
			}
			
			return group;
		});

		this.props.setGroups(newState);
	}

	render() {
		const participants = () => ({
			receiver: {
				id: this.state.conversation.id, 
				name: this.state.conversation.name
			},
			sender: {
				id: this.props.currentUser.id,
				name: this.props.currentUser.name
			}
		});

		const saveMessageToDatabase = (input) => {
			const theData = { action: "SAVE_MESSAGE", ...input };
			const theParams = {
				method: "POST",
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify(theData)
			};
	
			return fetch(process.env.REACT_APP_ENDPOINT, theParams)
		};
	
		const sendMessage = (values) => {
			const { receiver, sender } = participants();
	
			const message = {
				groups: receiver.id,
				tom: receiver.id,
				fromm: sender.id,
				message: values.content,
			}

			const save = saveMessageToDatabase(message);

			save.then(response => response.json())
				.then(data => {
					const payload = {
						id: data.id,
						to: receiver,
						from: sender,
						content: values.content,
						created_at: data.time,
					};

					this.socket.emit('chat', payload);
				})
				.catch(err => console.log(err));
		};

		const showIsTyping = (event) => {
			const { receiver, sender } = participants();
	
			const payload = {
				group: receiver,
				from: sender,
				created_at: new Date().toISOString()
			};
	
			this.socket.emit('typing', payload);
		};

		const groups = this.props.groups;
		const conversation = this.state.conversation;

		return (
			<div className="main-content">
				<div className={conversation ? "sidebar sidebar-mobile d-flex flex-column" : "sidebar d-flex flex-column"}>
					<div className="sidebar-group d-flex flex-column flex-grow-1">
						<Header />
						<div className="chat-title">
							<h5>
								Qruplar
							</h5>
						</div>
						<Groups>
							{groups.map(group => (
								<Group
									key={group.id}
									data={group}
									conversation={this.state.conversation}
									openConversation={this.openConversation}
								/>
							))}
						</Groups>
					</div>
				</div>
				<div className={conversation ? "chat chat-mobile" : "chat"}>
					{conversation ? (
						<Chat
							currentUser={this.props.currentUser}
							group={conversation}
							messagesLength={conversation.messages.length}
							closeConversation={this.closeConversation}
							handleSubmit={sendMessage}
							handleKeyUp={showIsTyping}
							
							triggerLoadMore={this.triggerLoadMore}
							count={this.props.count}
							sentMessage={this.props.sentMessage}
							setSentMessage={this.props.setSentMessage}
						/>
					) : (
						<div className="align-self-center">
							<div className="my-3 py-3 text-muted">
								<h5 className="d-none">
									Select a group to get in on the action
								</h5>
							</div>
						</div>
					)}
				</div>
			</div>
		);
	}
}
